import React, { useState } from "react";
import axios from "axios";

const API_URL = "https://sdi909uolk.execute-api.ap-south-1.amazonaws.com";
const HOUSEHOLD_ID = "sabari-household";
const CATEGORIES = ["Grocery", "Food", "Bills", "Travel", "Fuel", "Personal Care", "Shopping", "Other"];
const METHODS = ["cash", "bank", "credit_card"];

function AddExpense({ userId, token, onDone }) {
  const [amount, setAmount] = useState("");
  const [merchant, setMerchant] = useState("");
  const [category, setCategory] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!amount || !merchant) return;
    setSaving(true);
    try {
      await axios.post(
        `${API_URL}/expenses`,
        {
          household_id: HOUSEHOLD_ID,
          user_id: userId,
          amount: parseFloat(amount),
          merchant_name: merchant,
          category: category || undefined,
          payment_method: paymentMethod,
          expense_date: date,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onDone();
    } catch (err) {
      console.error("Failed to add expense:", err);
      alert("Something went wrong, try again.");
    }
    setSaving(false);
  };

  return (
    <div className="subpage">
      <h2 className="subpage-title">Add expense</h2>
      <form onSubmit={submit}>
        <div className="field-group">
          <label className="field-label">Amount (₹)</label>
          <input
            className="field-input"
            type="number"
            placeholder="0.00"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
          />
        </div>

        <div className="field-group">
          <label className="field-label">Merchant / note</label>
          <input
            className="field-input"
            type="text"
            placeholder="e.g. D-Mart, Zomato"
            value={merchant}
            onChange={(e) => setMerchant(e.target.value)}
            required
          />
        </div>

        <div className="field-group">
          <label className="field-label">Category (optional — auto-fills if known)</label>
          <div className="chip-row">
            {CATEGORIES.map((cat) => (
              <button
                type="button"
                key={cat}
                className={`chip-btn ${category === cat ? "active" : ""}`}
                onClick={() => setCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="field-group">
          <label className="field-label">Paid via</label>
          <div className="chip-row">
            {METHODS.map((method) => (
              <button
                type="button"
                key={method}
                className={`chip-btn ${paymentMethod === method ? "active" : ""}`}
                onClick={() => setPaymentMethod(method)}
              >
                {method === "credit_card" ? "Credit Card" : method[0].toUpperCase() + method.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="field-group">
          <label className="field-label">Date</label>
          <input
            className="field-input"
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-dark" disabled={saving}>
            {saving ? "Saving..." : "Save expense"}
          </button>
          <button type="button" className="btn" onClick={onDone}>Cancel</button>
        </div>
      </form>
    </div>
  );
}

export default AddExpense;